import { Box, Grid, Typography } from "@mui/material";

const OpeningHour = () => {
  return (
    <Box display='flex' sx={{
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      p: '1em',
      width: '100%', // {xs:'100%', md:'50%'},
    }}>
      <Typography variant='h2' sx={{ my: '1em', fontSize: '2.5em' }}>
        Opening Hours
      </Typography>
      <Grid container rowSpacing={{ xs: 3.5, md: 5 }} columnSpacing={{ xs: 1, md: 3 }}
        sx={{ fontSize: '2em', pb: '1em' }}
      >
        <Grid item xs={6} md={6} sx={{ textAlign: 'right', lineHeight: '1.5em' }}>
          Monday - Saturday
        </Grid>
        <Grid item xs={6} md={6} sx={{ lineHeight: '1.5em' }}>
          <Box display='flex' sx={{ alignItems: 'center', height: '100%', pl: '1em' }}>
            11 am - 8 pm
          </Box>
        </Grid>
        <Grid item xs={6} md={6} sx={{ textAlign: 'right' }}>Sunday</Grid>
        <Grid item xs={6} md={6} sx={{ pl: '1em' }}>
          <Box display='flex' sx={{ alignItems: 'center', height: '100%', pl: '1em' }}>Closed</Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OpeningHour;